<template>
  <div class="contentBox">
    <div class="breadCrumbs mt-50">
      <el-breadcrumb separator="/" class="ml-15">
        <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
        <el-breadcrumb-item>news</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="news">
      <ul class="newsUl">
        <li v-for="(item,key) in dataList" :key="key">
          <router-link :to="{name:'newsMain',params:{id:item.id}}" @click.native="childLink(item.id)">
            
            <div class="main">
              <p class="title">{{item.title}}</p>
              <p class="maintext">{{item.description}}</p>
              <p class="tips">
                <span class="sp1">
                  <i class="el-icon-time"></i>
                  {{item.document_time}}
                </span>
                <span class="sp2">
                  <i class="el-icon-view"></i>
                  {{item.view}}
                </span>
              </p>
            </div>
            <el-image
            :src="item.cover"
            fit="contain"></el-image>
          </router-link>
        </li>
      </ul>
        <div class="pageblock">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="pageData.page"
            :page-size="5"
            layout="total,  prev, pager, next, jumper"
            :total="pageData.total">
          </el-pagination>
        </div>
    </div>
  </div>
</template>

<script>
import "@/assets/css/news.less";
import apiSign from "../assets/js/apiSign";
export default {
  data() {
    return {
      dataList: [],
      readmore: "加载更多...",
      loading: false,
      pageData:{
        page: 1,
        total:0
      }
    };
  },
  mounted() {
    this.getNewsList();
  },
  methods: {
      handleCurrentChange(val) {
        this.pageData.page = val;
        this.getNewsList()
      },
    getNewsList() {
      let field = { rtime: apiSign.getTime(), page: this.pageData.page };
      this.axios
        .get(this.axios.defaults.baseURL + "/yiwei/news/lists", {
          headers: {
            sign: apiSign.sign(field)
          },
          params: field
        })
        .then(resp => {
          if (resp.data.code == 0) {
            this.pageData.total = resp.data.data.total;
            if(resp.data.data.data.length == 0){
             this.$message({
                message: '没有更多新闻了',
                type: 'warning'
              });
            }
            resp.data.data.data.sort(function(a, b){
              return a.document_time < b.document_time ? 1 : -1; // 这里改为大于号
            });
            this.dataList = resp.data.data.data;
          } else {
            this.$message({
              type: "error",
              message: resp.data.msg
            });
          }
        });
    },
    readMoreFn() {
      this.loading = true;
      this.readmore = "加载中...";
      let page = this.page;
      page += 1;
      this.page = page;
      this.getNewsList();
    },
    childLink(id){
      sessionStorage.setItem('newsid',id);

    }
  }
};
</script>
